import React from 'react';
export const WhyDifferent = () => {
  return <section className="mb-12" data-id="element-526">
      <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-527">
        Waarom dit anders is dan andere trainingsmethoden
      </h2>

      <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-528">
        Traditionele hondentraining draait om gehoorzaamheid: je hond leren doen
        wat jij wilt. Amee's methode draait om begrip en samenwerken: Je hond
        leren begrijpen en hoe hij je zorgt dat hij jou begrijpt.
      </p>

      <div className="bg-teal-50 border-l-4 border-teal-600 p-5 mb-6 rounded-r-lg" data-id="element-529">
        <p className="text-gray-800 leading-relaxed italic" data-id="element-530">
          "Het verschil is enorm," legt ze uit. "Bij training probeer je gedrag
          te forceren. Als je leert communiceren dan begrijp je elkaar en kan je
          samenwerken met je hond. Bovendien wordt je hond er veel relaxter
          van."
        </p>
      </div>
    </section>;
};